module.exports = __webpack_public_path__ + "img/al3.a0313398.png";